import axios from "axios";
import _ from "lodash";
import cloneDeep from "lodash/cloneDeep";
import React from "react";
import { withRouter } from "react-router-dom";
import { API_RESOURCES, ORDER_STATES } from "../../constants.js";
import { OrderFormCostPrice } from "./OrderFormCostPrice";
import { OrderFormDeliveryBilling } from "./OrderFormDeliveryBilling";
import { OrderFormInfo } from "./OrderFormInfo";
import { OrderFormInvoice } from "./OrderFormInvoice";
import { OrderFormManufacture } from "./OrderFormManufacture";
import { OrderFormPayment } from "./OrderFormPayment";
import { OrderFormPoGr } from "./OrderFormPoGr";
import { OrderFormPurchasePrice } from "./OrderFormPurchasePrice";
import { OrderFormRepair } from "./OrderFormRepair";

// Models
import { getQtyCategory, getWarrantyExpirationDate, itemCategoryName } from "../../models/ItemCategories";
import { getNewMR, MR_STATION_TYPE_DEFAULT } from "../../models/ManufactureRequest";
import { calTotalCost, init_order, is_complete, NEW_ORDER, ORDER_TABS, set_new_order_po_gr, validateDeliveryBilling, validateInstallation, validateInvoice, validateOrder, validatePayment, validatePoGr } from "../../models/Orders";
import { getCategoryTotalExpense, isDiscount, isItemDiscount, isItemExpense, new_expense } from "../../models/Quotations";

// Component
import { DocumentPreview } from "../global/DocumentPreview.js";
import ModalConfirmation from "../global/ModalConfirmation";
import Spinner from "../global/Spinner";

// Functions
import { formatApiDate } from "../../functions/Date";
import { FEE_MULTIPLIER, solveFeeNew } from "../../functions/FeePurchaseCalculation";
import { saveMultiple, } from "../../functions/Number";
import { objectIndexOf, objectIsEmpty, toSnakeCase } from "../../functions/Object";
import { uniqueKey } from "../../functions/Random";
import ErrorMessage from "../global/ErrorMessage.js";

class OrderForm extends React.Component {
  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(props.location.search);
    const selected_tab = urlParams.get("tab");
    this.state = {
      current_tab: selected_tab ? ORDER_TABS[selected_tab] : ORDER_TABS.info,
      selected_id: parseInt(props.id),
      order: cloneDeep(NEW_ORDER),
      distance: null,
      disabled: false,
      is_canceling: false,
      is_loading: false,
      is_leaving: false,
      is_updated: false,
      is_changing_contract: false,
      errors: {},
      resetKey: uniqueKey(),
      resetKeyPurchasePricing: uniqueKey(),
      resetKeyNote: uniqueKey(),
      resetKeyPOdoc: "",

      //PO GR
      po_gr_contract_ids: [],

      // purchase price
      is_reset_contract_cate: false,
      is_reset_expense: false,

      load_cate: 0,
      cate_length: 0,
    };

    this.onChangeFormTab = this.onChangeFormTab.bind(this);
    this.onChangeOrderNo = this.onChangeOrderNo.bind(this);
    this.onChangeOrderDate = this.onChangeOrderDate.bind(this);

    this.onChangeOrderDetails = this.onChangeOrderDetails.bind(this);
    this.onClickLinkToQuo = this.onClickLinkToQuo.bind(this);

    // payment
    this.onSelectBank = this.onSelectBank.bind(this);
    this.onSelectPaymentMethod = this.onSelectPaymentMethod.bind(this);
    this.onChangePaymentDate = this.onChangePaymentDate.bind(this);
    this.onChangePaymentNote = this.onChangePaymentNote.bind(this);
    this.onUploadPaySlip = this.onUploadPaySlip.bind(this);
    this.onDeletePaySlip = this.onDeletePaySlip.bind(this);
    this.onClickGenerateMR = this.onClickGenerateMR.bind(this);

    // Purchase Price
    this.onResetContractPrice = this.onResetContractPrice.bind(this);
    this.onChangeItemDetails = this.onChangeItemDetails.bind(this);
    this.onChangeAddedCost = this.onChangeAddedCost.bind(this);
    this.onApplyAddedCost = this.onApplyAddedCost.bind(this);
    this.onAddFee = this.onAddFee.bind(this);
    this.onChangeFeeDetails = this.onChangeFeeDetails.bind(this);
    this.onChangeContract = this.onChangeContract.bind(this);
    this.onDeleteExpense = this.onDeleteExpense.bind(this);

    // PO GR
    this.onAddNewPoGr = this.onAddNewPoGr.bind(this);
    this.onDeletePoGr = this.onDeletePoGr.bind(this);
    this.onChangePoGrContract = this.onChangePoGrContract.bind(this);
    this.onChangePoGrDetails = this.onChangePoGrDetails.bind(this);
    this.onChangePoGrDateDetails = this.onChangePoGrDateDetails.bind(this);

    // Manufacture
    this.onGetWarrantyCodes = this.onGetWarrantyCodes.bind(this);
    this.onDeleteWarrantyCodes = this.onDeleteWarrantyCodes.bind(this);
    this.onChangeItemManufactureDetails = this.onChangeItemManufactureDetails.bind(this);

    // Invoice
    this.onUploadInvoice = this.onUploadInvoice.bind(this);

    // note
    this.onChangeNote = this.onChangeNote.bind(this);

    // Repair Log
    this.onChangeRepairLog = this.onChangeRepairLog.bind(this);
    this.onAddRepairLog = this.onAddRepairLog.bind(this);
    this.onRemoveRepairLog = this.onRemoveRepairLog.bind(this);

    // submit
    this.onHandleSubmit = this.onHandleSubmit.bind(this);
    this.putPurchasingOrder = this.putPurchasingOrder.bind(this);

    // Cancel
    this.onHandleCancelModal = this.onHandleCancelModal.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onCancelOrder = this.onCancelOrder.bind(this);

    // back
    this.backToOrderIndex = this.backToOrderIndex.bind(this);
    this.onHandleModalBack = this.onHandleModalBack.bind(this);
    this.onClickBack = this.onClickBack.bind(this);

    // Approved Date
    this.checkItemContract = this.checkItemContract.bind(this);

    // Custom Ship-To
    this.onUpdateCustomShipTo = this.onUpdateCustomShipTo.bind(this);
  }

  componentDidMount() {
    if (this.state.selected_id !== null) {
      this.getPurchasingOrder();
      // this.setState({ order: TEMP_ORDERS.filter(elm => elm.id === this.state.selected_id)[0], resetKey: uniqueKey()})
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let { order, is_reset_expense } = this.state;
    // reset purchase prices all items in categories
    if (!objectIsEmpty(this.state.is_reset_contract_cate)) {
      let { quotation } = order;
      let item_ids = [];
      order.purchasing_order_items.forEach((elm) => item_ids.push(elm.item_id));
      this.state.is_reset_contract_cate.forEach((reset_cate) => {
        this.setContractByItemCategory(
          {
            is_active: true,
            approved_date: formatApiDate(quotation.approved_date),
            item_category_id: reset_cate,
            province_id: quotation.client_station.address.province_id,
            item_ids: item_ids,
          },
          is_reset_expense,
          "update",
          true
        );
      });

      this.setState({ is_reset_contract_cate: false });
    }

    // check order's status
    if (order.state !== ORDER_STATES.completed.name && is_complete(order.order_flag)) {
      order.state = ORDER_STATES.completed.name;
      this.setState({ order: order });
    }
  }

  getPurchasingOrder() {
    this.setState({ is_loading: true });
    axios
      .get(`${process.env.REACT_APP_API_URL}/${API_RESOURCES.po}/${this.state.selected_id}`)
      .then((response) => {
        let current_contract = {};
        let current_installation_date = {};
        let order = init_order(response.data);
        let distance = order.quotation.client_station.distance;
        if (order.order_flag.init_completed !== true) {
          for (var key in order.order_item_categories) {

            order.purchasing_order_items.forEach((item) => {
              if (item.is_parent) {
                const find_sub_item = order.purchasing_order_items.filter((p_item) => p_item.from_parent && p_item.from_parent_item_id === item.item_id);
                const sum_sub_price = find_sub_item.reduce((prev, curr) => (prev += curr.contract_price * curr.qty), 0);

                item.contract_price = sum_sub_price;
              }
            });

            this.reCalExpense(order.purchasing_order_items, order.order_item_categories[key], distance);
          }
          order.total_cost = calTotalCost(order);
        }

        for (let key in order.order_item_categories) {
          current_contract[key] = order.order_item_categories[key].contract_id;
        }

        order.purchasing_order_items.forEach((item) => {
          current_installation_date[item.id] = item.installation_date;
        });

        order.order_flag.init_completed = true;

        this.setState({
          order: order,
          current_contract: current_contract,
          current_installation_date: current_installation_date,
          po_gr_contract_ids: this.getPoGrContractOptionIds(order),
          distance: distance,
          disabled: order.state === ORDER_STATES.cancelled.name,
          resetKeyPOdoc: uniqueKey(),
          resetKey: uniqueKey(),
          resetKeyNote: uniqueKey(),
        });

        this.checkItemContract(order, "get", true);
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          is_loading: false,
        });
      })
      .then(function () {
        // always executed
      });
  }

  getSumTotalCostForSave(data) {
    let total_cost = 0;

    data.purchasing_order_items.forEach((item) => {
      let sumCost = 0;
      sumCost = item.inventories.reduce((prev, curr) => prev + (curr.calc_unit_price + curr.added_unit_cost), sumCost);
      total_cost = total_cost + sumCost;
    });
    return total_cost;
  }

  putPurchasingOrder(newState) {
    let { order, is_leaving, current_installation_date } = this.state;
    let changed_installation_date = this.checkInstallationChanged(order, current_installation_date);
    const error = this.checkSaveError(order.purchasing_order_items);

    if (error !== "") {
      alert(error);
      return;
    }

    if (newState !== undefined) {
      order.state = newState;
    }
    order.user_id = this.props.current_user.id;
    if (order.dc_id === 1) {
      order.total_cost = this.getSumTotalCostForSave(order);
    }

    axios
      .put(`${process.env.REACT_APP_API_URL}/${API_RESOURCES.po}/${order.id}`, {
        changed_installation_date: changed_installation_date,
        po: order,
      })
      .then((response) => {
        if (is_leaving) {
          window.location.href = `/${API_RESOURCES.order}`;
        } else {
          if (response.data) {
            order.s3_base_url = response.data.s3_base_url;
            if (response.data.order_po_grs.length > 0) {
              order.order_po_grs = response.data.order_po_grs;
            }
          }
          let current_contract = {};
          for (let key in order.order_item_categories) {
            current_contract[key] = order.order_item_categories[key].contract_id;
          }
          let current_installation_date = {};
          order.purchasing_order_items.forEach((po_item) => {
            current_installation_date[po_item.id] = po_item.installation_date;
          });

          this.setState({
            order: order,
            current_contract: current_contract,
            current_installation_date: current_installation_date,
            is_loading: false,
            is_updated: false,
            resetKeyPOdoc: uniqueKey(),
            errors: {},
          });

          alert("Order Saved!");
          this.checkItemContract(order, "save");
        }
      })
      .catch((error) => {
        this.setState({ is_loading: false });
      });
    this.setState({ is_loading: true });
  }

  checkSaveError(items) {
    const { order } = this.state;
    let errors = "";
    if (order.dc_id === 0) {
      items.forEach((item) => {
        if (item.contract_price === 0 && !item.is_active) {
          errors = errors + `- ราคาขาขายของ ${item.name} เป็น 0 บาท และไม่พบสินค้านี้ในสัญญาที่เลือก\n`;
        } else if (item.contract_price !== 0 && !item.is_active) {
          errors = errors + `- ไม่พบสินค้า ${item.name} นี้ในสัญญาที่เลือก\n`;
        }
      });
    }
    return errors;
  }

  onHandleSubmit(e, newState) {
    let { order, is_changing_contract } = this.state;
    let changed_contract = this.checkContractChange();
    let is_changed_contract = changed_contract.length > 0;

    this.setState({ cate_length: 0, load_cate: 0 });

    if (is_changed_contract && !is_changing_contract) {
      this.onHandleChangeContractModal(true);
    } else {
      if (is_changed_contract) {
        let params = [];
        changed_contract.forEach((item) => {
          if (item.prev_contract_id)
            params.push({
              po_item_id: item.po_item.id,
              prev_contract_id: item.prev_contract_id,
              next_contract_id: item.next_contract_id,
              client_station_id: order.quotation.client_station.id,
            });
        });

        if (params.length > 0) {
          axios
            .post(`${process.env.REACT_APP_API_URL}/log/change_contract`, {
              params: params,
            })
            .then((response) => {
              this.onHandleChangeContractModal(false);
              let errors = validateOrder(order, newState);
              if (objectIsEmpty(errors)) {
                this.putPurchasingOrder(newState);
              } else {
                alert("กรุณากรอกข้อมูลให้ครบถ้วน");
                this.setState({ errors: errors });
              }
            });
        } else {
          this.onHandleChangeContractModal(false);
          let errors = validateOrder(order, newState);
          if (objectIsEmpty(errors)) {
            this.putPurchasingOrder(newState);
          } else {
            alert("กรุณากรอกข้อมูลให้ครบถ้วน");
            this.setState({ errors: errors });
          }
        }
      } else {
        let errors = validateOrder(order, newState);
        if (objectIsEmpty(errors)) {
          this.putPurchasingOrder(newState);
        } else {
          alert("กรุณากรอกข้อมูลให้ครบถ้วน");
          this.setState({ errors: errors });
        }
      }
    }
  }

  onChangeOrderDetails(e) {
    let order = this.state.order;
    let errors = this.state.errors;
    
    // Special handling for ship_to field - only allow 0-9 and preserve leading zeros
    if (e.target.name === "ship_to") {
      const value = e.target.value;
      // Only allow digits 0-9
      if (value !== "" && !/^\d+$/.test(value)) {
        return;
      }
      order = {
        ...order,
        ship_to: value,
      };
      if (errors.ship_to) {
        const { ship_to, ...remainingErrors } = errors;
        errors = remainingErrors;
      }
    } else {
      order = {
        ...order,
        [e.target.name]: e.target.value,
      };
    }
    
    order = this.setDeliveryBillingCompletedFlag(order);
    if (e.target.name === "order_code") {
      order.order_flag.po_payment_compeleted = validatePayment(order);
    }
    this.setState({ order: order, errors: errors, is_updated: true });
  }

  /********* Custom Ship-To (Start) *********/
  onUpdateCustomShipTo() {
    let { order, errors } = this.state;
    
    if (!order.ship_to || String(order.ship_to).trim() === "") {
      this.setState({ 
        errors: { ...errors, ship_to: "กรุณากรอกหมายเลข Ship-To" } 
      });
      return;
    }

    const { ship_to, ...remainingErrors } = errors;
    this.setState({ is_loading: true, errors: remainingErrors });
    
    axios
      .put(`${process.env.REACT_APP_API_URL}/${API_RESOURCES.po}/${order.id}/update_custom_ship_to`, {
        custom_ship_to: order.ship_to,
      })
      .then((response) => {
        if (response.data && response.data.s3_base_url) {
          order.s3_base_url = response.data.s3_base_url;
        }
        this.setState({
          order: order,
          is_loading: false,
          resetKeyPOdoc: uniqueKey(),
        });
        alert("อัพเดทหมายเลข Ship-To สำเร็จ!");
      })
      .catch((error) => {
        console.error("Failed to update custom Ship-To for order:", order && order.id, error);
        
        let errorDetail = "";
        if (error && error.response && error.response.data) {
          if (typeof error.response.data.message === "string" && error.response.data.message.trim() !== "") {
            errorDetail = error.response.data.message.trim();
          } else if (typeof error.response.data.error === "string" && error.response.data.error.trim() !== "") {
            errorDetail = error.response.data.error.trim();
          }
        } else if (error && typeof error.message === "string" && error.message.trim() !== "") {
          errorDetail = error.message.trim();
        }
        
        const baseMessage = "เกิดข้อผิดพลาดในการอัพเดทหมายเลข Ship-To";
        const errorMessage = errorDetail 
          ? `${baseMessage}: ${errorDetail}` 
          : `${baseMessage} กรุณาลองใหม่อีกครั้ง`;
        
        this.setState({ 
          is_loading: false,
          errors: { ...this.state.errors, ship_to: errorMessage }
        });
      });
  }
  /********* Custom Ship-To (End) *********/

  /********* Note (Start) *********/
  onChangeNote(note) {
    let { order } = this.state;
    let index = objectIndexOf(order.order_notes, "page_nb", note.page_nb);

    if (index < 0) {
      order.order_notes.push(note);
    } else {
      order.order_notes[index] = note;
    }

    this.setState({ order: order, is_updated: true });
  }
  /********* Note (End) *********/

  /********* Repair Log (Start) *********/
  setRepairLogUser(repair_log) {
    repair_log.user_id = this.props.current_user.id;
    repair_log.user = {
      firstname: this.props.current_user.firstname,
      lastname: this.props.current_user.lastname,
    };
    return repair_log;
  }

  onChangeRepairLog(id, name, value) {
    let { order } = this.state;
    let index = objectIndexOf(order.order_repairs, "id", id);
    order.order_repairs[index] = {
      ...order.order_repairs[index],
      [name]: value,
    };
    order.order_repairs[index] = this.setRepairLogUser(order.order_repairs[index]);
    this.setState({ order: order, is_updated: true });
  }
  onAddRepairLog(new_log) {
    let { order } = this.state;
    let de_new_log = this.setRepairLogUser(new_log);
    order.order_repairs.push(de_new_log);
    this.setState({ order: order, is_updated: true });
  }
  onRemoveRepairLog(id) {
    let { order } = this.state;
    order.order_repairs = order.order_repairs.filter((elm) => elm.id !== id);
    this.setState({ order: order, is_updated: true });
  }
  /********* Repair Log (End) *********/

  onChangeQuotationDetails = (e, field) => {
    let { order } = this.state;
    order.quotation[field] = {
      ...order.quotation[field],
      [e.target.name]: e.target.value,
    };

    this.setState({ order: order, is_updated: true });
  };

  onChangeCustomerStationDetails(e) {
    let { order } = this.state;
    order.quotation.client_station = {
      ...order.quotation.client_station,
      [e.target.name]: e.target.value,
    };

    this.setState({ order: order, is_updated: true });
  }

  onChangeFormTab(tab) {
    this.setState({ current_tab: tab });
  }

  onChangeOrderNo(e) {
    let order = this.state.order;
    order.po_no = e.target.value;
    this.setState({ order: order });
  }

  onChangeOrderDate(date, field) {
    let order = this.state.order;
    order[field] = formatApiDate(date);
    if (field === "invoice_received_date") {
      order = this.onValidateInvoice(order);
    }
    this.setState({ order: order });
  }

  onClickLinkToQuo(id) {
    window.location.href = `/${API_RESOURCES.quotation}/${id}`;
  }

  /********* Payment (Start) *********/
  onSelectBank(value, e) {
    let { order } = this.state;
    order.payment_method.bank_id = value;
    this.setState({ order: order, is_updated: true });
  }

  onSelectPaymentMethod(value) {
    let { order } = this.state;
    order.payment_method.method_type = value;
    order.payment_method.note = "";
    order.payment_method.bank_id = null;
    this.setStatePayment(order);
  }

  onChangePaymentDate(date, field) {
    let { order } = this.state;
    order.payment_method[field] = formatApiDate(date);
    this.setStatePayment(order);
  }

  onChangePaymentNote(e) {
    let { order } = this.state;
    order.payment_method.note = e.target.value;
    this.setState({ order: order, is_update: true });
  }

  onUploadPaySlip(key) {
    let { order } = this.state;
    order.payment_method.s3_slip_url = key;
    this.setStatePayment(order);
  }

  onDeletePaySlip() {
    let { order } = this.state;
    order.payment_method.s3_slip_url = null;
    this.setStatePayment(order);
  }

  setStatePayment(order) {
    order.order_flag.po_payment_compeleted = validatePayment(order);
    this.setState({ order: order, is_update: true });
  }
  /********* Payment (End) *********/

  /********* Purchase Price (Start) *********/
  onResetContractPrice(item_category_id_arr) {
    this.setState({
      is_reset_contract_cate: item_category_id_arr,
      is_reset_expense: item_category_id_arr[0],
    });
  }
  confirmPurchasePrices = (value) => {
    let order = this.state.order;
    order.order_flag.purchase_price_completed = value;

    this.setState({
      order: order,
      resetKeyPurchasePricing: uniqueKey(),
      is_update: true,
    });
  };

  reCalExpense(items, item_category, distance) {
    let target_items = items.filter((item) => item.item_category_id === item_category.item_category_id && !item.is_mbom && !item.from_parent);
    let sum_qty = target_items.reduce((sum, item) => (sum += parseInt(item.qty)), 0);

    if (target_items.length > 0) {
      // recal fee qty (start)
      item_category.item_category_expenses
        .filter((expense) => !isDiscount(expense))
        .forEach((elm, index) => {
          if (elm.is_new !== true) {
            let input_qty = sum_qty;
            if (isItemExpense(elm.resource_type)) {
              let target_item = items.filter((item) => item.item_id === elm.resource_id)[0];
              input_qty = target_item ? target_item.qty : 0;
            }
            let caled_qtys = getQtyCategory(target_items, elm, distance, input_qty);
            if (elm.is_custom_qty !== true) {
              elm.qty = caled_qtys.qty;
            }
            elm.item_qty = caled_qtys.item_qty;
          }
        });
      // recal fee qty (end)

      // recal item discount qty (start)
      let discountGroupByName = _.groupBy(item_category.item_category_expenses, function (elm) {
        if (!elm.is_custom_qty && !elm.is_new && isItemDiscount(elm)) {
          return elm.name;
        } else {
          return "";
        }
      });
      Object.keys(discountGroupByName).forEach((key) => {
        if (key !== "") {
          let all_qty_in_group = 0;
          discountGroupByName[key].forEach((elm, index) => {
            all_qty_in_group += parseInt(items.filter((item) => item.item_id === elm.resource_id)[0].qty);
            if (index !== 0) {
              elm.item_qty = 0;
            }
          });

          let elm = discountGroupByName[key][0];
          let input_qty = sum_qty;
          if (isItemExpense(elm.resource_type)) {
            input_qty = all_qty_in_group;
          }
          let caled_qtys = getQtyCategory(target_items, elm, distance, input_qty);
          if (elm.is_custom_qty !== true) {
            elm.qty = caled_qtys.qty;
          }
          elm.item_qty = caled_qtys.item_qty;
        }
      });
      // recal item discount qty (end)

      // set qty to 0 if there is a match discount with a fee (start)
      let GroupByName = _.groupBy(item_category.item_category_expenses, function (elm) {
        return elm.name;
      });
      Object.keys(discountGroupByName).forEach((key) => {
        if (key !== "" && GroupByName[key].length >= 2) {
          let group_sum = getCategoryTotalExpense(GroupByName[key], true);

          if (group_sum >= 0) {
            let discount = GroupByName[key].filter((elm) => isDiscount(elm))[0];
            let fee = GroupByName[key].filter((elm) => !isDiscount(elm))[0];
            if (fee && discount) {
              //======= Method 3 per qty ========
              if (fee.method_type === 3) {
                if (fee.is_custom_qty !== true) {
                  fee.qty = fee.qty - discount.qty;
                }
                discount.qty = 0;
              }
              //======= Method 5 per km * qty ========
              if (fee.method_type === 5) {
                fee.item_qty = fee.item_qty - discount.item_qty;
                discount.item_qty = 0;
              }
            }
          }
        }
      });

      let is_type_7 = null

      item_category.item_category_expenses.forEach((cate) => {
        if (cate.method_type === 7 && cate.qty > cate.from_value) {
          if (is_type_7) {
            if (cate.qty > is_type_7.from_value && is_type_7.from_value < cate.from_value) {
              is_type_7 = cate
            }
          } else {
            is_type_7 = cate
          }

        }
      })

      let sum_expense = getCategoryTotalExpense(item_category.item_category_expenses, true, is_type_7 ? is_type_7 : false);
      let item_qty_arr = target_items.map((item) => {
        if (item.from_parent) return false;
        return parseInt(item.qty) || 0;
      });

      let item_price_arr = target_items.map((item) => {
        if (item.from_parent) return false;
        return item.contract_price ? parseInt(item.contract_price) : parseInt(item.price) || 0;
      });

      // let suggest_fee = solveFee(saveMultiple(sum_expense, FEE_MULTIPLIER), item_qty_arr);

      let suggest_fee = solveFeeNew(saveMultiple(sum_expense, FEE_MULTIPLIER), item_qty_arr, item_price_arr);
      let res_ratio = suggest_fee[2];
      let suggest_qty_4 = suggest_fee[4];
      // handle
      // [3,3] 200 =>  [3333, 3334, 3335] [3, 2, 1]
      // [3] 100 => [3333, 3334] [2, 1]]
      // [2,1] 100 => [3333, 3334] [2, 1]]
      if (suggest_qty_4.length !== item_qty_arr.length) {
        let suggest_qty_index = 0;
        let de_suggest_fee_2 = [];
        for (let index in item_qty_arr) {
          if (item_qty_arr[index] === suggest_qty_4[suggest_qty_index]) {
            de_suggest_fee_2.push(res_ratio[suggest_qty_index]);
            suggest_qty_index += 1;
          } else {
            let item_qty = item_qty_arr[index];
            let fee_arr = [];
            while (item_qty > 0) {
              item_qty -= suggest_qty_4[suggest_qty_index];
              for (let i = 0; i < suggest_qty_4[suggest_qty_index]; i++) {
                fee_arr.push(res_ratio[suggest_qty_index]);
              }
              suggest_qty_index += 1;
            }
            de_suggest_fee_2.push(fee_arr);
          }
        }
        res_ratio = de_suggest_fee_2;
        // let suggest_qty_index = 0
        // for (let elm of target_items) {
        //   if (elm.qty !== suggest_qty_4[suggest_qty_index]){
        //     let item_qty = elm.qty
        //     let sub_index = 0
        //     while (item_qty > 0) {
        //       if (sub_index !== 0) {
        //         let de_elm = cloneDeep(elm)
        //         de_elm.qty = suggest_qty_4[suggest_qty_index]
        //         items.push(de_elm)
        //       } else {
        //         elm.qty = suggest_qty_4[suggest_qty_index]
        //       }
        //       item_qty = item_qty - suggest_qty_4[suggest_qty_index]
        //       sub_index += 1
        //       suggest_qty_index += 1
        //     }
        //   } else {
        //     suggest_qty_index += 1
        //   }
        // }
        // target_items = items.filter((item) => item.item_category_id === item_category.item_category_id)
      }

      res_ratio.forEach((value, index) => {
        if (Array.isArray(value)) {
          target_items[index].expense_ratio = 0;
          target_items[index].expense_ratio_arr = value;
        } else {
          target_items[index].expense_ratio = value;
          target_items[index].expense_ratio_arr = null;
        }
      });
    }
  }

  onChangeItemDetails(e, id) {
    let { order } = this.state;
    let { purchasing_order_items, order_item_categories } = order;
    let de_item_index = purchasing_order_items.findIndex((x) => x.id === id);

    purchasing_order_items[de_item_index] = {
      ...purchasing_order_items[de_item_index],
      [e.target.name]: e.target.value,
    };

    if (purchasing_order_items[de_item_index].from_parent) {
      const parent_index = purchasing_order_items.findIndex((item) => purchasing_order_items[de_item_index].from_parent_item_id === item.item_id);
      const sub_list = purchasing_order_items.filter((item) => item.from_parent && item.from_parent_item_id === purchasing_order_items[parent_index].item_id);
      const sum_sub_price = sub_list.reduce((prev, curr) => (prev += curr.contract_price * curr.qty), 0);

      purchasing_order_items[parent_index] = {
        ...purchasing_order_items[parent_index],
        contract_price: sum_sub_price,
      };
    }

    // Recalculate expenses
    this.reCalExpense(purchasing_order_items, order_item_categories[purchasing_order_items[de_item_index].item_category_id], this.state.distance);
    order.total_cost = calTotalCost(order);
    this.setState({ order: order, is_updated: true });
  }

  onChangeAddedCost(e, elm, data) {
    const value = parseFloat(e.target.value);
    let { order } = this.state;
    let { purchasing_order_items } = order;

    // find position op "elm"
    let find_po_order_index = purchasing_order_items.findIndex((po) => po.id === data.id);
    let find_inventory_index = purchasing_order_items[find_po_order_index].inventories.findIndex((inventory) => inventory.id === elm.id);

    // set value to position
    purchasing_order_items[find_po_order_index].inventories[find_inventory_index].added_unit_cost = value;

    this.setState({ order: order });
  }

  onApplyAddedCost(e, elm, data) {
    const value = parseFloat(e);
    let { order } = this.state;
    let { purchasing_order_items } = order;

    // find position op "elm"
    let find_po_order_index = purchasing_order_items.findIndex((po) => po.id === data.id);
    let find_inventory_index = purchasing_order_items[find_po_order_index].inventories.findIndex((inventory) => inventory.id === elm.id);

    // set value to position
    purchasing_order_items[find_po_order_index].inventories.forEach((inventory) => {
      inventory.added_unit_cost = value || 0;
    });

    this.setState({ order: order });
  }

  onAddFee(id, index, item_category_id) {
    let { order } = this.state;
    let category_expenses = order.order_item_categories[item_category_id].item_category_expenses;
    let edited_index = category_expenses.findIndex((x) => x.id === id);
    let clone_cost = cloneDeep(category_expenses[edited_index]);

    clone_cost.id = uniqueKey();
    clone_cost.position = index;
    clone_cost.is_new = false;
    category_expenses.push(clone_cost);
    // Reset
    category_expenses[edited_index] = cloneDeep(new_expense);
    category_expenses[edited_index].item_category_id = item_category_id;

    this.setState({ order: order, is_updated: true });
  }

  onChangeFeeDetails(e, id, item_category_id) {
    let { order } = this.state;
    let category_expenses = order.order_item_categories[item_category_id].item_category_expenses;
    let de_item_index = category_expenses.findIndex((x) => x.id === id);
    category_expenses[de_item_index] = {
      ...category_expenses[de_item_index],
      [e.target.name]: e.target.value,
    };

    // update flag
    if (e.target.name === "qty") {
      category_expenses[de_item_index].is_custom_qty = true;
    }

    // Recalculate expenses
    this.reCalExpense(order.purchasing_order_items, order.order_item_categories[item_category_id], this.state.distance);
    order.total_cost = calTotalCost(order);
    this.setState({ order: order, is_updated: true });
  }

  displayChangeContractConfirm() {
    if (this.state.is_changing_contract) {
      const content = (
        <React.Fragment>
          <div>
            เมื่อสัญญาถูกเปลี่ยนในออเดอร์ รายการที่แสดงให้กับผู้ผลิตรายเก่าจะแสดงเป็นสถานะ <b className="text-danger">ยกเลิก</b> และโยกย้ายไปยังผู้ผลิตรายใหม่ <b className="text-success">ในสถานะเดิม</b>
          </div>
          <br />
          <div className="text-primary">เพื่อความไม่สับสน ควรชี้แจ้งกับผู้ผลิตเองอีกครั้ง หากเปลี่ยนสัญญา</div>
          <br />
          <div>คลิก 'ตกลง' เพื่อ save</div>
        </React.Fragment>
      );
      return <ModalConfirmation isOpen={true} title="มีการเปลี่ยนสัญญาในออเดอร์" content={content} onConfirm={this.onHandleSubmit} onCancel={() => this.onHandleChangeContractModal(false)} onCustomAction={(e) => { }} />;
    }
  }

  onHandleChangeContractModal(value) {
    this.setState({ is_changing_contract: value });
  }

  checkContractChange() {
    let { order, current_contract } = this.state;
    let { order_item_categories, purchasing_order_items } = order;
    let key_contract_change = [];
    let item_contract_change = [];
    for (let key in order_item_categories) {
      if (order_item_categories[key].contract_id != current_contract[key]) {
        key_contract_change.push(parseInt(key));
      }
    }
    purchasing_order_items.forEach((item) => {
      // console.log(item);
      if (key_contract_change.includes(item.item_category_id)) {
        item_contract_change.push({
          po_item: item,
          prev_contract_id: current_contract[item.item_category_id],
          next_contract_id: order_item_categories[item.item_category_id].contract_id,
        });
      }
    });
    return item_contract_change;
  }

  onChangeContract(value, e, item_category_id) {
    let { order, current_contract } = this.state;
    order.order_item_categories[item_category_id].contract_id = value;
    const item_ids = order.purchasing_order_items.reduce((results, elm) => {
      if (elm.item_category_id == item_category_id) results.push(elm.item_id);
      return results;
    }, []);

    this.setContractByItemCategory(
      {
        id: value,
        item_category_id: item_category_id,
        item_ids: item_ids,
      },
      item_category_id,
      "update"
    );
    this.setState({
      order: order,
      po_gr_contract_ids: this.getPoGrContractOptionIds(order),
    });

    // this.setState({
    //   is_reset_contract_cate: [item_category_id],
    //   is_reset_expense: item_category_id,
    //   order: order,
    //   resetContractByCateSelect: uniqueKey(),
    //   po_gr_contract_ids: this.getPoGrContractOptionIds(order)
    // })
  }

  checkItemContract(order, type = "none", isDefaultLoad = false) {
    let { is_reset_expense } = this.state;

    let reset_cates = Object.keys(order.order_item_categories);
    let item_ids = [];

    this.setState({ cate_length: reset_cates.length, load_cate: 0, order: order });

    if (order.purchasing_order_items && type !== "save") {
      let { quotation } = order;
      order.purchasing_order_items.map((elm) => item_ids.push(elm.item_id));
      reset_cates.map((reset_cate) => {
        let contract_id = order.order_item_categories[reset_cate].contract_id;
        this.setContractByItemCategory(
          {
            is_active: true,
            approved_date: formatApiDate(quotation.approved_date),
            item_category_id: reset_cate,
            id: contract_id,
            // province_id: quotation.client_station.address.province_id,
            item_ids: item_ids,
          },
          is_reset_expense,
          type,
          isDefaultLoad
        );
      });
    }
  }

  setContractByItemCategory(filter_params, is_reset_expense, type = "none", isDefaultLoad = false) {
    // console.log("=====615 filter_params", filter_params);
    let filters = { for_mr: false };
    Object.keys(filter_params).forEach((key) => {
      filters[key] = filter_params[key];
    });

    let params = {
      sort: JSON.stringify(["created_at", "DESC"]),
      filter: filters,
    };

    this.setState({ is_loading: true });
    axios
      .get(`${process.env.REACT_APP_API_URL}/contract_by_cate`, {
        params: params,
      })
      .then((response) => {
        // console.log(response.data);
        let { order } = this.state;

        if (response.data.id) {
          let contract = response.data;
          let contract_cate = contract.contract_item_categories[0];
          let all_expenses = contract_cate.contract_item_category_fees;
          contract_cate.contract_items.forEach((elm) => {
            all_expenses = all_expenses.concat(elm.contract_item_fees, elm.contract_item_discounts);
          });

          if (type === "update") {
            order.order_item_categories[filter_params.item_category_id].contract_id = contract.id;
          }

          // Update expenses
          order = this.updateExpenseContractPrice(order, filter_params.item_category_id, all_expenses, is_reset_expense);
          // Update items

          order.purchasing_order_items
            .filter((elm) => elm.item_category_id == filter_params.item_category_id)
            .forEach((item) => {
              let contract_item = contract_cate.contract_items.filter((elm) => elm.item_id === item.item_id)[0];

              if (contract_item) {
                if (contract_item.price === 0) {
                  if (type === "update") {
                    item.contract_price = item.contract_price ? item.contract_price : contract_item.price;
                  }
                } else {
                  if (isDefaultLoad) {
                    item.contract_price = item.contract_price;
                  } else {
                    item.contract_price = contract_item.price;
                  }
                }
                item.contract_item_id = contract_item.id;
                item.is_active = contract_item.is_active;
              } else {
                item.contract_price = item.contract_price ? item.contract_price : contract_item.price;
                item.contract_item_id = contract_item.id;
                item.is_active = false;
              }
            });

          if (is_reset_expense) {
            // Recalculate expenses
            this.reCalExpense(order.purchasing_order_items, order.order_item_categories[is_reset_expense], this.state.distance);
          }

          this.setState({
            order: order,
            po_gr_contract_ids: this.getPoGrContractOptionIds(order),
            is_reset_expense: false,
            load_cate: this.state.load_cate + 1,
          });
        } else {
          this.setState({ load_cate: this.state.load_cate + 1 });
        }

        if (this.state.cate_length === this.state.load_cate && type !== "update") {
          this.setState({ is_loading: false });
          if (this.state.current_tab === 2) {
            this.errorAlert(order.purchasing_order_items);
          }
        }

        if (type === "update") {
          this.setState({ is_loading: false });
          if (this.state.current_tab === 2) {
            this.errorAlert(order.purchasing_order_items);
          }
        }
      })
      .catch(() => {
        this.setState({ is_loading: false });
      })
      .then(function () {
        // always executed
      });
  }

  checkInstallationChanged(order, current_installation_date) {
    let { purchasing_order_items } = order;
    let changed_installation_date = {};
    purchasing_order_items.forEach((item) => {
      if (current_installation_date[item.id] !== item.installation_date) {
        changed_installation_date[item.id] = current_installation_date[item.id];
      }
    });
    return changed_installation_date;
  }

  errorAlert(item) {
    let select_error = this.checkContrackStatus(item);
    if (select_error) {
      alert(select_error);
      this.setState({ is_loading: false });
      return;
    }
  }

  checkContrackStatus(items) {
    const { order } = this.state;
    let errors = "";
    if (order.dc_id === 0) {
      items.forEach((item) => {
        if (item.contract_price === 0 && item.is_active) {
          errors = errors + `- ราคาขาขายของ ${item.name} เป็น 0 บาท\n`;
        } else if (item.contract_price === 0 && !item.is_active) {
          errors = errors + `- ราคาขาขายของ ${item.name} เป็น 0 บาท และไม่พบสินค้านี้ในสัญญาที่เลือก\n`;
        } else if (item.contract_price !== 0 && !item.is_active) {
          errors = errors + `- ไม่พบสินค้า ${item.name} นี้ในสัญญาที่เลือก\n`;
        }
      });
    }

    return errors;
  }

  updateExpenseContractPrice(order, item_category_id, all_expenses, reset) {
    let reset_exp = reset ? reset : false;
    order.order_item_categories[item_category_id].item_category_expenses.map((exp) => {
      if (exp.resource_type_id) {
        let contract_exp = all_expenses.filter((elm) => elm[`${toSnakeCase(exp.resource_type)}_id`] === exp.resource_type_id)[0];

        if (contract_exp) {
          if (reset_exp) {
            // genuine contract change: refresh price from the newly selected contract
            exp.contract_price = contract_exp.price;
          } else {
            // initial / default load: preserve saved price, only fill a missing (falsy) one
            exp.contract_price = exp.contract_price ? exp.contract_price : contract_exp.price;
          }
        } else {
          console.log("======== Not found contract_exp for %s", exp.name);
        }
      }
      if (reset_exp) {
        exp.is_custom_qty = false;
      }
    });

    return order;
  }

  onDeleteExpense(elm) {
    // ส่ง elm ที่อยู่ใน item_category_expenses array มาให้
    // console.log("elm :>> ", elm);
    let { order } = this.state;
    let { order_item_categories } = order;
    order_item_categories[elm.item_category_id].item_category_expenses = order_item_categories[elm.item_category_id].item_category_expenses.filter((temp) => (isDiscount(elm) ? temp.name !== elm.name : temp.id !== elm.id));

    // Recalculate expenses
    this.reCalExpense(order.purchasing_order_items, order_item_categories[elm.item_category_id], this.state.distance);
    this.setState({ order: order, is_updated: true });
  }
  /********* Purchase Price (End) *********/

  /********* PO GR (Start) *********/
  getPoGrContractOptionIds(order) {
    let ids = Object.keys(order.order_item_categories).reduce((results, key) => {
      results.push(order.order_item_categories[key].contract_id);
      return results;
    }, []);

    return ids;
  }
  confirmPoGr = (value) => {
    let order = this.state.order;
    order.order_flag.po_gr_completed = value;

    this.setState({ order: order, is_update: true });
  };
  setPoGrCompletedFlag(order) {
    order.order_flag.po_gr_completed = validatePoGr(order.order_po_grs, this.state.po_gr_contract_ids);
    return order;
  }
  onAddNewPoGr() {
    let { order } = this.state;
    order.order_po_grs.push(set_new_order_po_gr());
    this.setState({ order: order, is_updated: true });
  }
  onDeletePoGr(id) {
    let { order } = this.state;
    const index = order.order_po_grs.findIndex((elm) => elm.id === id);
    const removed_item = order.order_po_grs.splice(index, 1)[0];
    order = this.setPoGrCompletedFlag(order);
    this.setState({
      order: order,
      is_updated: true,
      is_loading: !removed_item.is_new,
    });

    if (!removed_item.is_new) {
      console.log("============ is not new ");
      axios
        .delete(`${process.env.REACT_APP_API_URL}/${API_RESOURCES.order_po_gr}/${id}`, { data: {}, headers: { "Content-Type": "text/plain" } })
        .then((response) => {
          this.setState({ is_loading: false });
        })
        .catch((error) => {
          console.log(error);
          order.order_po_grs.push(removed_item);
          order = this.setPoGrCompletedFlag(order);
          this.setState({ order: order, is_loading: false });
        });
    } else {
      console.log("============ is new :)))))))))))))");
    }
  }
  onChangePoGrContract(contract_id, id) {
    let { order } = this.state;
    let po_gr_index = order.order_po_grs.findIndex((x) => x.id === id);
    order.order_po_grs[po_gr_index].contract_id = contract_id;
    order = this.setPoGrCompletedFlag(order);
    this.setState({ order: order, is_updated: true });
  }
  onChangePoGrDetails(e, id) {
    let { order } = this.state;
    let po_gr_index = order.order_po_grs.findIndex((x) => x.id === id);
    order.order_po_grs[po_gr_index] = {
      ...order.order_po_grs[po_gr_index],
      [e.target.name]: e.target.value,
    };
    order = this.setPoGrCompletedFlag(order);
    this.setState({ order: order, is_updated: true });
  }
  onChangePoGrDateDetails(date, field, id) {
    let { order } = this.state;
    let po_gr_index = order.order_po_grs.findIndex((x) => x.id === id);
    order.order_po_grs[po_gr_index][field] = formatApiDate(date);
    this.setState({ order: order, is_updated: true });
  }

  onClickGenerateMR() {
    let { order } = this.state;
    let { order_po_grs, quotation, order_item_categories } = order;
    let po_gr_arr = [];
    let contract_ids = [];

    for (let item_cate_key in order_item_categories) {
      let item_cate = order_item_categories[item_cate_key];
      let contract_id = item_cate.contract_id;
      if (contract_id && !contract_ids.includes(contract_id)) {
        contract_ids.push(contract_id);
        let po_gr = order_po_grs.filter((elm) => elm.contract_id === contract_id)[0];
        if (!po_gr || (po_gr && !po_gr.manufacture_request_id)) {
          let new_mr = getNewMR(this.props.current_user);
          for (let key in order_item_categories) {
            let item_category = order_item_categories[key];

            if (item_category.contract_id === contract_id) {
              let manufacture_request_station = {
                client_station_id: quotation.client_station.id,
                station_name: quotation.client_station.name,
                station_type: MR_STATION_TYPE_DEFAULT,
                item_category_id: key,
                item_category_name: itemCategoryName(item_category),
                toggle_mr_remark: true,
              };
              new_mr.manufacture_request_stations.push(manufacture_request_station);
            }
          }

          new_mr.contract_id = contract_id;

          po_gr_arr.push({
            order_po_gr_id: po_gr ? po_gr.id : null,
            contract_id: contract_id,
            order_id: order.id,
            mr: new_mr,
          });
        }
      }
    }

    if (po_gr_arr.length > 0) {
      this.setState({ is_loading: true });
      axios
        .post(`${process.env.REACT_APP_API_URL}/${API_RESOURCES.mr}/auto_gen`, {
          mrs: po_gr_arr,
        })
        .then((response) => {
          for (let res_po_gr of response.data) {
            let index = order_po_grs.findIndex((elm) => elm.contract_id === res_po_gr.contract_id);
            if (index > -1) {
              order.order_po_grs[index].manufacture_request_id = res_po_gr.manufacture_request_id;
            } else {
              let new_po_gr = set_new_order_po_gr();
              new_po_gr.id = res_po_gr.id;
              new_po_gr.contract_id = res_po_gr.contract_id;
              new_po_gr.order_id = res_po_gr.order_id;
              new_po_gr.manufacture_request_id = res_po_gr.manufacture_request_id;
              new_po_gr.is_new = false;
              order.order_po_grs.push(new_po_gr);
            }
          }
          // clear new empty po_gr
          order.order_po_grs = order.order_po_grs.filter((elm) => elm.is_new !== true && elm.contract_id !== null);
          this.setState({ order: order, is_loading: false });
          this.putPurchasingOrder();
        })
        .catch((error) => {
          console.log(error);
          this.setState({ is_loading: false });
        });
    } else {
      alert("ไม่พบสัญญาที่สามารถสร้างใบสั่งจ้างผลิตได้");
    }
  }
  /********* PO GR (End) *********/

  /********* Delilvery Billing (Start) *********/
  setDeliveryBillingCompletedFlag(order) {
    order.order_flag.delivery_billing_completed = validateDeliveryBilling(order);
    return order;
  }
  /********* Delilvery Billing (End) *********/

  /********* Manufacture (Start) *********/
  onGetWarrantyCodes(item_id) {
    let { order } = this.state;
    let index = objectIndexOf(order.purchasing_order_items, "id", item_id);
    let order_item_cate = order.order_item_categories[order.purchasing_order_items[index].item_category_id];
    let asset_code = order.purchasing_order_items[index].item.asset_code ? order.purchasing_order_items[index].item.asset_code : order_item_cate.item_category.code;

    if (order_item_cate.contract_id) {
      let body = {
        quotation_item_id: order.purchasing_order_items[index].quotation_item_id,
        purchasing_order_item_id: item_id,
        item_category_id: order.purchasing_order_items[index].item_category_id,
        asset_code: asset_code,
        contract_id: order_item_cate.contract_id,
        qty: order.purchasing_order_items[index].qty,
      };

      if (order.purchasing_order_items[index].item.asset_code) {
        body.item_id = order.purchasing_order_items[index].item_id;
      }

      this.setState({
        is_loading: true,
      });
      axios
        .put(`${process.env.REACT_APP_API_URL}/${API_RESOURCES.po}/get_warranty_codes`, body)
        .then((response) => {
          order.purchasing_order_items[index].warranty_codes = response.data;

          this.setState({
            order: order,
            is_loading: false,
          });
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data) {
            alert(error.response.data.Message);
          }
          this.setState({
            is_loading: false,
          });
        })
        .then(function () {
          // always executed
        });
    } else {
      alert(`ไม่สามารถขอรหัสทรัพย์สินได้ เนื่องจากยังไม่ได้ระบุสัญญาใน ${order_item_cate.sys_name}`);
    }
  }

  onDeleteWarrantyCodes(item_id) {
    let { order } = this.state;
    let index = objectIndexOf(order.purchasing_order_items, "id", item_id);

    let body = {
      purchasing_order_item_id: item_id,
    };

    this.setState({
      is_loading: true,
    });
    axios
      .put(`${process.env.REACT_APP_API_URL}/${API_RESOURCES.po}/delete_warranty_codes`, body)
      .then((response) => {
        order.purchasing_order_items[index].warranty_codes = [];

        this.setState({
          order: order,
          is_loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response.data) {
          alert(error.response.data.Message);
        }
        this.setState({
          is_loading: false,
        });
      })
      .then(function () {
        // always executed
      });
  }

  onChangeItemManufactureDetails(e, id) {
    let { order } = this.state;
    let { purchasing_order_items } = order;
    let de_item_index = purchasing_order_items.findIndex((x) => x.id === id);

    purchasing_order_items[de_item_index] = {
      ...purchasing_order_items[de_item_index],
      [e.target.name]: e.target.value,
    };
    purchasing_order_items[de_item_index].expiration_date = formatApiDate(getWarrantyExpirationDate(purchasing_order_items[de_item_index]));

    order.order_flag.installation_completed = validateInstallation(order);
    this.setState({ order: order, is_updated: true });
  }
  /********* Manufacture (End) *********/

  /********* Invoice (Start) *********/
  onUploadInvoice(key) {
    let { order } = this.state;
    order.s3_invoice_url = key;
    order = this.onValidateInvoice(order);
    this.setState({ order: order, is_updated: true });
  }

  onValidateInvoice(order) {
    order.order_flag.invoice_complated = validateInvoice(order);
    return order;
  }
  /********* Invoice (End) *********/

  /* ========================================================= */
  /* Cancel (start) */
  onHandleCancelModal(value) {
    this.setState({ is_canceling: value });
  }
  onCancel() {
    if (this.state.order.cancel_note) {
      this.onCancelOrder(ORDER_STATES.cancelled.name);
    } else {
      alert("โปรดระบุเหตุผล");
    }
  }
  onCancelOrder(state) {
    let { order } = this.state;
    order.state = state;
    axios
      .put(`${process.env.REACT_APP_API_URL}/${API_RESOURCES.po}/${order.id}/cancel`, {
        state: order.state,
        cancel_note: order.cancel_note,
        user_id: this.props.current_user.id,
      })
      .then((response) => {
        for (let index in order.purchasing_order_items) {
          order.purchasing_order_items[index].warranty_codes = [];
        }
        this.setState({
          order: order,
          is_loading: false,
          is_updated: false,
          is_canceling: false,
          disabled: true,
        });

        alert("Cancel Success!");
      })
      .catch((error) => {
        console.log(error);
        this.setState({ is_loading: false });
      });

    this.setState({ is_loading: true });
  }

  /* Cancel (end) */
  /* ========================================================= */

  /* ========================================================= */
  /* Back (start) */
  backToOrderIndex() {
    this.props.history.push({
      pathname: `/${API_RESOURCES.order}`,
      search: this.props.location.search,
    });
  }
  onHandleModalBack(value) {
    this.setState({ is_leaving: value });
  }
  onClickBack() {
    if (this.state.is_updated) {
      this.onHandleModalBack(true);
    } else {
      this.backToOrderIndex();
    }
  }
  displayBackConfirmation() {
    if (this.state.is_leaving) {
      return <ModalConfirmation isOpen={true} title="บันทึกใบสั่งซื้อสินค้า ?" content="มีการแก้ไขที่ยังไม่ได้ถูกบันทึก ต้องการบันทึก?" btnDanger="ไม่บันทึก" onConfirm={this.onHandleSubmit} onCustomAction={this.backToOrderIndex} onCancel={() => this.onHandleModalBack(false)} />;
    }
  }
  /* Back (end) */
  /* ========================================================= */

  /* ========================================================= */
  /* Display (start) */
  actionBtns() {
    const SaveBtn = () => (
      <button type="button" className="btn btn-primary btn-sm" onClick={this.onHandleSubmit}>
        Save
      </button>
    );
    const SubmitBtn = () => (
      <button type="button" className="btn btn-primary btn-sm ml-2" onClick={(e) => this.onHandleSubmit(e, ORDER_STATES.completed.name)}>
        Complete
      </button>
    );
    const CancelBtn = () => (
      <button type="button" className="btn btn-danger btn-sm ml-2" onClick={() => this.onHandleCancelModal(true)}>
        Cancel
      </button>
    );
    const CanceledBtn = () => (
      <button type="button" className="btn btn-danger btn-sm ml-2" onClick={() => this.onHandleCancelModal(true)}>
        เหตุผล
      </button>
    );

    switch (this.state.order.state) {
      case ORDER_STATES.in_progress.name:
        return (
          <React.Fragment>
            <SaveBtn />
            <SubmitBtn />
            <CancelBtn />
          </React.Fragment>
        );
      case ORDER_STATES.cancelled.name:
        return (
          <React.Fragment>
            <CanceledBtn />
          </React.Fragment>
        );
      default:
        return (
          <React.Fragment>
            <SaveBtn />
          </React.Fragment>
        );
    }
  }

  displayPages() {
    let { order, disabled, current_tab, resetKeyPOdoc, po_gr_contract_ids, resetKeyPurchasePricing, resetKeyNote, errors } = this.state;

    // console.log("this.state.order", this.state.order);

    const displayPage = () => {
      switch (current_tab) {
        case ORDER_TABS.payment:
          return (
            <React.Fragment>
              <div className="offset-lg-1 col-lg-10 px-3 pb-3 mt-sm-2">
                <OrderFormPayment
                  page_nb={current_tab}
                  order={order}
                  onChangeOrderDetails={this.onChangeOrderDetails}
                  onSelectPaymentMethod={this.onSelectPaymentMethod}
                  onSelectBank={this.onSelectBank}
                  onChangePaymentNote={this.onChangePaymentNote}
                  onChangePaymentDate={this.onChangePaymentDate}
                  onUploadPaySlip={this.onUploadPaySlip}
                  onDeletePaySlip={this.onDeletePaySlip}
                  onChangeNote={this.onChangeNote}
                  disabled={disabled}
                  resetKeyNote={resetKeyNote}
                />
                {/* Note */}
                <div className="card-box p-3 mt-1">
                  <div className="row">
                    <div className="col-4 col-md-2 pr-0 mt-2">
                      <label>หมายเหตุ (PDF)</label>
                    </div>
                    <div className="col-8 col-md-10 mt-2">
                      <textarea type="order-note" className="form-control" name="note" rows={5} onChange={this.onChangeOrderDetails} value={order.note} disabled={disabled}></textarea>
                    </div>
                  </div>
                </div>

                <h5 className="mt-4 pb-1">แก้ไขหมายเลข Ship-To สำหรับแสดงบน PDF</h5>
                <div className="card-box p-3 mt-1">
                  <div className="row">
                    <div className="col-4 col-md-2 pr-0 mt-2">
                      <label>หมายเลข Ship-To</label>
                    </div>
                    <div className="col-8 col-md-10 mt-2">
                      <div className="d-flex">
                        <input 
                          type="text"
                          className="form-control" 
                          id="order-ship-to" 
                          name="ship_to" 
                          onChange={this.onChangeOrderDetails} 
                          value={order.ship_to || ''} 
                          disabled={disabled}
                          pattern="[0-9]*"
                          inputMode="numeric"
                        />
                        <button 
                          type="button" 
                          className="btn btn-primary btn-sm ml-2" 
                          onClick={this.onUpdateCustomShipTo}
                          disabled={disabled}
                          style={{ whiteSpace: 'nowrap' }}
                        >
                          อัพเดท PDF
                        </button>
                      </div>
                      <ErrorMessage errorKey="ship_to" errorMessages={errors} />
                    </div>
                  </div>
                </div>
                
                <DocumentPreview docName="ใบสั่งซื้อสินค้า" url={order.s3_base_url} resetKey={resetKeyPOdoc} />
              </div>
            </React.Fragment>
          );
        case ORDER_TABS.purchase_price:
          return (
            <div className="col-12 px-3 pb-3 mt-2">
              <OrderFormPurchasePrice
                checkItemContract={this.checkItemContract}
                page_nb={current_tab}
                order={order}
                disabled={disabled}
                confirmPurchasePrices={this.confirmPurchasePrices}
                onChangeNote={this.onChangeNote}
                onResetContractPrice={this.onResetContractPrice}
                onChangeFeeDetails={this.onChangeFeeDetails}
                onChangeItemDetails={this.onChangeItemDetails}
                onChangeContract={this.onChangeContract}
                onDeleteExpense={this.onDeleteExpense}
                onAddFee={this.onAddFee}
                key={resetKeyPurchasePricing}
              />
            </div>
          );
        case ORDER_TABS.cost_price:
          return (
            <div className="col-12 px-3 pb-3 mt-2">
              <OrderFormCostPrice
                page_nb={current_tab}
                order={order}
                disabled={disabled}
                confirmPurchasePrices={this.confirmPurchasePrices}
                onChangeNote={this.onChangeNote}
                onResetContractPrice={this.onResetContractPrice}
                onChangeFeeDetails={this.onChangeFeeDetails}
                onChangeItemDetails={this.onChangeItemDetails}
                onChangeAddedCost={this.onChangeAddedCost}
                onApplyAddedCost={this.onApplyAddedCost}
                onChangeContract={this.onChangeContract}
                onDeleteExpense={this.onDeleteExpense}
                onAddFee={this.onAddFee}
                key={resetKeyPurchasePricing}
              />
            </div>
          );
        case ORDER_TABS.manufacturer:
          return (
            <OrderFormManufacture
              page_nb={current_tab}
              order={order}
              disabled={disabled}
              key={this.state.resetKey}
              onChangeNote={this.onChangeNote}
              onChangeItemManufactureDetails={this.onChangeItemManufactureDetails}
              onGetWarrantyCodes={this.onGetWarrantyCodes}
              onDeleteWarrantyCodes={this.onDeleteWarrantyCodes}
              resetKeyNote={resetKeyNote}
            />
          );
        case ORDER_TABS.po_gr:
          return (
            <div className="offset-lg-1 col-lg-10 px-3 pb-3 mt-2">
              <OrderFormPoGr
                page_nb={current_tab}
                order={order}
                po_gr_contract_ids={po_gr_contract_ids}
                disabled={disabled}
                onChangeNote={this.onChangeNote}
                onAddNewPoGr={this.onAddNewPoGr}
                onDeletePoGr={this.onDeletePoGr}
                onChangePoGrContract={this.onChangePoGrContract}
                onChangePoGrDetails={this.onChangePoGrDetails}
                onChangePoGrDateDetails={this.onChangePoGrDateDetails}
                confirmPoGr={this.confirmPoGr}
                onClickGenerateMR={this.onClickGenerateMR}
                key={this.state.resetKey}
                resetKeyNote={resetKeyNote}
                errors={errors}
              />
            </div>
          );
        case ORDER_TABS.delivery_billing:
          return (
            <div className="offset-lg-1 col-lg-10 px-3 pb-3 mt-2">
              <OrderFormDeliveryBilling
                page_nb={current_tab}
                order={order}
                disabled={disabled}
                // disabled={disabled || is_delivery_billing_disabled(order.order_flag)}
                // warning={is_delivery_billing_disabled(order.order_flag) ? "หมายเหตุ: ยังไม่สามารถกรอกข้อมูลได้ กรุณาระบุข้อมูล PO/GR ให้เสร็จสมบูรณ์ก่อน" : null}
                onChangeOrderDetails={this.onChangeOrderDetails}
                onChangeOrderDate={this.onChangeOrderDate}
                onChangeNote={this.onChangeNote}
                resetKeyNote={resetKeyNote}
              />
            </div>
          );
        case ORDER_TABS.invoice:
          return (
            <div className="offset-lg-1 col-lg-10 px-3 pb-3 mt-2">
              <OrderFormInvoice
                page_nb={current_tab}
                order={order}
                disabled={disabled}
                // warning = {is_invoice_disabled(order.order_flag) ? 'หมายเหตุ: ยังไม่สามารถกรอกข้อมูลได้ถ้าขั้นตอนอื่นยังไม่สำเร็จ' : null}
                onChangeOrderDetails={this.onChangeOrderDetails}
                onChangeOrderDate={this.onChangeOrderDate}
                onChangeNote={this.onChangeNote}
                onUploadInvoice={this.onUploadInvoice}
                resetKeyNote={resetKeyNote}
              />
            </div>
          );
        case ORDER_TABS.repair:
          return (
            <div className="col-12 px-3 pb-3 mt-2">
              <OrderFormRepair page_nb={current_tab} current_user={this.props.current_user} order={order} disabled={disabled} onChangeRepairLog={this.onChangeRepairLog} onAddRepairLog={this.onAddRepairLog} onRemoveRepairLog={this.onRemoveRepairLog} onChangeNote={this.onChangeNote} />
            </div>
          );
        default:
          return (
            <div className="offset-lg-1 col-lg-10 px-3 pb-3 mt-2">
              <OrderFormInfo
                errors={errors}
                page_nb={current_tab}
                order={order}
                disabled={disabled}
                onChangeQuotationDetails={this.onChangeQuotationDetails}
                onChangeOrderDetails={this.onChangeOrderDetails}
                onChangeOrderDate={this.onChangeOrderDate}
                onChangeNote={this.onChangeNote}
                resetKeyNote={resetKeyNote}
              />
            </div>
          );
      }
    };
    return <React.Fragment>{displayPage()}</React.Fragment>;
  }

  cancelOrder() {
    let { disabled, order } = this.state;
    let disable_cancel_modal = order.state === ORDER_STATES.cancelled.name;
    if (this.state.is_canceling) {
      const content = (cancel_note) => (
        <React.Fragment>
          <div className="row pb-2 mb-2">
            <div className="col-12 col-md-4 pt-md-2">
              <label>เหตุผล</label>
            </div>
            <div className="col pt-2">
              <textarea className="form-control" type="text" name="cancel_note" defaultValue={this.state.disabled ? cancel_note : ""} onChange={this.onChangeOrderDetails} rows="4" disabled={disable_cancel_modal}></textarea>
            </div>
          </div>
        </React.Fragment>
      );
      return <ModalConfirmation isOpen={true} title="ยกเลิกใบสั่งซื้อสินค้า" content={content(order.cancel_note)} onConfirm={disable_cancel_modal ? undefined : this.onCancel} onCancel={() => this.onHandleCancelModal(false)} />;
    }
  }

  displayCheckmark(active) {
    return <span className={`checkmark-wrapper ${active ? "active" : ""} symbol-checkmark`}></span>;
  }
  /* Display (end) */
  /* ========================================================= */

  render() {
    let { current_tab, order } = this.state;
    let { delivery_billing_completed, installation_completed, invoice_complated, po_gr_completed, po_payment_compeleted, purchase_price_completed } = order.order_flag;
    let stateColor = "warning";

    if (this.state.order) {
      switch (this.state.order.state) {
        case ORDER_STATES.cancelled.name:
          stateColor = "danger";
          break;
        case ORDER_STATES.completed.name:
          stateColor = "success";
          break;
        default:
      }
    }
    return (
      <React.Fragment>
        <Spinner loading={this.state.is_loading} allCategory={this.state.cate_length} allLoadeCategory={this.state.load_cate} />
        <div className="pb-sm-3 px-3">
          <div className="row">
            <div className="col-9 pr-0 d-flex flex-row">
              <h2 className="d-none d-md-block">Order Form</h2>
              <h5 className="mb-2 pb-1 mt-auto px-2 color-darkblue text-wrap">{this.state.order.code}</h5>
              <span className={`badge badge-pill badge-${stateColor} quo-state-tag`}>{this.state.order.state}</span>
            </div>
            <div className="col-3 text-right">
              <button type="button" className="btn btn-outline-primary btn-sm" onClick={this.onClickBack}>
                Back
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-9">
              <ul className="nav nav-tabs tab-responsive">
                <li className="nav-item">
                  <a className={`nav-link ${current_tab === ORDER_TABS.info ? "active" : ""}`} onClick={() => this.onChangeFormTab(ORDER_TABS.info)}>
                    Info
                  </a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${current_tab === ORDER_TABS.payment ? "active" : ""}`} onClick={() => this.onChangeFormTab(ORDER_TABS.payment)}>
                    ราคาขาขาย{this.displayCheckmark(po_payment_compeleted)}
                  </a>
                </li>
                {order.dc_id === 0 ? (
                  <li className="nav-item">
                    <a className={`nav-link ${current_tab === ORDER_TABS.purchase_price ? "active" : ""}`} onClick={() => this.onChangeFormTab(ORDER_TABS.purchase_price)}>
                      ราคาขาซื้อ{this.displayCheckmark(purchase_price_completed)}
                    </a>
                  </li>
                ) : (
                  <li className="nav-item">
                    <a className={`nav-link ${current_tab === ORDER_TABS.cost_price ? "active" : ""}`} onClick={() => this.onChangeFormTab(ORDER_TABS.cost_price)}>
                      ราคาทุน{this.displayCheckmark(purchase_price_completed)}
                    </a>
                  </li>
                )}
                {order.dc_id === 0 && (
                  <li className="nav-item">
                    <a className={`nav-link ${current_tab === ORDER_TABS.po_gr ? "active" : ""}`} onClick={() => this.onChangeFormTab(ORDER_TABS.po_gr)}>
                      PO/GR{order.dc_id === 0 && this.displayCheckmark(po_gr_completed)}
                    </a>
                  </li>
                )}
                <li className="nav-item">
                  <a className={`nav-link ${current_tab === ORDER_TABS.delivery_billing ? "active" : ""}`} onClick={() => this.onChangeFormTab(ORDER_TABS.delivery_billing)}>
                    Delivery{order.dc_id === 0 ? "/Billing" : ""}
                    {this.displayCheckmark(delivery_billing_completed)}
                  </a>
                </li>
                <li className="nav-item">
                  <a className={`nav-link ${current_tab === ORDER_TABS.manufacturer ? "active" : ""}`} onClick={() => this.onChangeFormTab(ORDER_TABS.manufacturer)}>
                    Installation{this.displayCheckmark(installation_completed)}
                  </a>
                </li>
                {order.dc_id === 0 && (
                  <li className="nav-item">
                    <a className={`nav-link ${current_tab === ORDER_TABS.invoice ? "active" : ""}`} onClick={() => this.onChangeFormTab(ORDER_TABS.invoice)}>
                      Invoice{order.dc_id === 0 && this.displayCheckmark(invoice_complated)}
                    </a>
                  </li>
                )}
                <li className="nav-item">
                  <a className={`nav-link ${current_tab === ORDER_TABS.repair ? "active" : ""}`} onClick={() => this.onChangeFormTab(ORDER_TABS.repair)}>
                    แจ้งซ่อม
                  </a>
                </li>
                {/* <li className="nav-item">
                  <a className={`nav-link ${(current_tab === ORDER_TABS.documents ? 'active' : '')}`} onClick={() => this.onChangeFormTab(ORDER_TABS.documents)}>Preview and Summary</a>
                </li> */}
              </ul>
            </div>
            <div className="col-12 col-md-3 mt-2">
              <div className="text-right">{this.actionBtns()}</div>
            </div>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          {this.displayPages()}
          {this.cancelOrder()}
        </form>
        {this.displayBackConfirmation()}
        {this.displayChangeContractConfirm()}
      </React.Fragment>
    );
  }
}
export default withRouter(OrderForm);
